// extracted by mini-css-extract-plugin
export var bounce = "_l5-1";
export var generatingText = "_l5-6";
export var lightning = "_l5-4";
export var popup = "_l5-5";
export var progressBar = "_l5-7";
export var progressFill = "_l5-8";
export var progressShimmer = "_l5-9";
export var progressText = "_l5-a";
export var shimmer = "_l5-3";
export var uploadIcon = "_l5-0";
export var uploadingText = "_l5-2";